module.exports = __webpack_public_path__ + "img/speedometerArrow copy.16c72655.svg";